export function buildObtenerPaisesResponse(obtenerPaisesResponse) {
    return {
        paisesDTO : obtenerPaisesResponse.paisesDTO,
        esRespOK: obtenerPaisesResponse.respuestaOk,
        respCodigo: obtenerPaisesResponse.codigoRespuesta,
        respMensaje: obtenerPaisesResponse.mensajeRespuesta,
    }
}